import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    border: `1px solid ${theme.palette.dividerV2.main}`,
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
    boxShadow: theme.shadows[8],
  },
}))
